import { useEffect, useState } from "react";
import { Link2, Headphones, MessageSquare, BadgeCheck, Timer, BellRing, Package } from "lucide-react";
import api from "@/lib/api";

const hrs = (h) => (h === null || h === undefined ? "—" : h < 1 ? `${Math.round(h * 60)} min` : h < 48 ? `${h.toFixed(h < 10 ? 1 : 0)} h` : `${(h / 24).toFixed(1)} j`);
const pct = (r) => (r === null || r === undefined ? "—" : `${Math.round(r * 100)} %`);

// Billing card: shared mock-ups (Cue Sheet links) — plays, notes, approval rate, average client turnaround, per theme.
export default function MockupStatsCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/cuesheet/share-stats").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || !data.links) return null;
  const kpis = [
    { icon: Link2, label: "liens", value: `${data.links}`, sub: `${data.active} actif${data.active > 1 ? "s" : ""}`, tid: "links" },
    { icon: Headphones, label: "écoutes", value: data.plays, sub: `${data.comments} note${data.comments > 1 ? "s" : ""}`, tid: "plays" },
    { icon: BadgeCheck, label: "taux de validation", value: pct(data.approval_rate), sub: `${data.approved} validée${data.approved > 1 ? "s" : ""} / ${data.sent} envoyée${data.sent > 1 ? "s" : ""}`, tid: "approval" },
    { icon: Timer, label: "délai moyen de retour", value: hrs(data.avg_feedback_hours), sub: `validation ${hrs(data.avg_approval_hours)}`, tid: "delay" },
  ];
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="mockup-stats-card">
      <div className="flex items-center justify-between mb-1 gap-3 flex-wrap">
        <h3 className="font-display text-lg font-bold flex items-center gap-2"><Link2 size={18} className="text-fuchsia-400" /> Maquettes partagées</h3>
        <span className="text-xs font-mono text-muted-foreground inline-flex items-center gap-3" data-testid="mockup-stats-meta"><span className="inline-flex items-center gap-1"><BellRing size={11} /> {data.reminders} rappel{data.reminders > 1 ? "s" : ""}</span><span className="inline-flex items-center gap-1"><Package size={11} /> {data.bundle_downloads} pack{data.bundle_downloads > 1 ? "s" : ""}</span></span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">Liens publics des cue sheets : écoutes, notes client, validations et temps entre l'envoi et le premier retour (note ou validation).</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {kpis.map((k) => (
          <div key={k.tid} className="rounded-xl bg-background border border-border px-3 py-2.5" data-testid={`mockup-stats-${k.tid}`}>
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground inline-flex items-center gap-1"><k.icon size={11} /> {k.label}</p>
            <p className="font-display text-2xl font-bold mt-0.5">{k.value}</p>
            <p className="text-[11px] text-muted-foreground">{k.sub}</p>
          </div>
        ))}
      </div>
      {data.themes.length > 0 && (
        <div className="mt-4 space-y-1.5" data-testid="mockup-stats-themes">
          {data.themes.map((t) => (
            <div key={t.theme_id} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs rounded-lg bg-background border border-border px-3 py-1.5" data-testid={`mockup-stats-row-${t.theme_id}`}>
              <span className="flex-1 min-w-[8rem] truncate font-medium">{t.theme}</span>
              <span className="font-mono text-muted-foreground">{t.links} lien{t.links > 1 ? "s" : ""} · V{t.versions}</span>
              <span className="font-mono text-fuchsia-300 inline-flex items-center gap-1"><Headphones size={11} /> {t.plays}</span>
              <span className="font-mono text-amber-300 inline-flex items-center gap-1"><MessageSquare size={11} /> {t.comments}</span>
              <span className={`font-mono inline-flex items-center gap-1 ${t.approved ? "text-emerald-300" : "text-muted-foreground"}`}><BadgeCheck size={11} /> {t.approved}/{t.sent || t.links}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
